export enum RequestStatuses {
    OPEN = "OPEN",
    CLOSED = "CLOSED",
    UNCLASSIFIED = "",
}
